export function actionProgressStats(actions) {
  const list = Array.isArray(actions) ? actions : [];
  const totalActions = list.length;
  const completedActions = list.filter((action) => action.status === "completed").length;
  const inProgressActions = list.filter((action) => action.status === "in-progress").length;
  const highImpactCompleted = list.filter(
    (action) => action.status === "completed" && action.impact === "high",
  ).length;
  const estimatedTimeRemaining = list
    .filter((action) => action.status !== "completed")
    .reduce(
      (sum, action) =>
        sum + (Number(action.time_estimate || action.timeEstimate) || 0),
      0,
    );

  return {
    totalActions,
    completedActions,
    inProgressActions,
    estimatedTimeRemaining,
    highImpactCompleted,
    completionPercentage:
      totalActions > 0 ? Math.round((completedActions / totalActions) * 100) : 0,
  };
}
